<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="dialogVisible" ref="modal">        
        <div class="u-window m-video-modal">
            <div class="u-btn close" @click="destroyElement"></div>
            <div id="playCon">
                <iframe v-bind:src="'https://dhvod.17m3.com/4.2.1/player.html?vid='+ vid" allow="autoplay" allowfullscreen="true" frameborder="0" scrolling="no" class="video-iframe" width="100%" height="100%"></iframe>
            </div>
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>      
</template>

<script>
export default {
    data (){
        let vm = this
        return {
            dialogVisible : false,
            vid: 'b4d01070846344819566baf400ac23a3',
        }
    },
    methods : {
        destroyElement () {
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },           
    },
}
</script>

<style scoped>
.m-video-modal{
    width: 920px;
    height: 520px;  
    border : 5px solid #000;
    background-color: #333;    
}

#playCon{
    width: 920px;
    height: 520px;   
}

.u-btn.close{
    position: absolute;
    top: -24px;
    right: -40px;
    width: 32px;
    height: 34px;
    background-image: url(~@/assets/images/pc/vote/btn-close.png);
}

@media screen and (max-device-width: 1024px){
    /* .dialog-view .u-btn.close{
        right: -73px;
    } */

    .m-video-modal{
        width: 578px;
        height: 324px;  
        border : 5px solid #000;
        background-color: #333;    
    }

    #playCon{
        width: 576px;
        height: 324px;    
    }

}
</style>


// WEBPACK FOOTER //
// src/components/video/video.vue